import React, { useMemo } from 'react';
import { Box, Stack } from '@mui/material';
import { CustomTypography, SingleChoiceSelect, TextSearch } from '@shared/ui';
import { useGetClassTypeAndPlace } from '@shared/data-access';
import { CLASS_TYPE_CATEGORY } from '@shared/types';
import styled from 'styled-components';


const StyledWrapper = styled.div`
  background-color: #fff;
  border-radius: 1em;
  padding: 0.5em 1rem 1rem 1rem;
  width: 80%;
`;

interface Props {
  filters: {
    classType: string;
    category: string;
    classPlace: string;
    search: string;
  };
  onChange: (patch: any) => void;
}

export const ClassFiltersBar: React.FC<Props> = ({
  filters,
  onChange,
}) => {
  const { data } = useGetClassTypeAndPlace();

  const classPlaces = data?.classPlaces || [];

  return (
    <Stack justifyContent={'center'} alignItems={'center'}>
      <StyledWrapper>
        <CustomTypography fontSize={'1rem'} color='#000' fontWeight={700} value='Tìm lớp' />
        <Stack
          direction='row'
          spacing={2}
          mt={1}
          flexDirection={{
            md: 'row',
          }}
        >
          <TextSearch label='Tìm kiếm...' value={filters.search} onChange={value => onChange({ search: value })} />

          <SingleChoiceSelect
            label='Cấp lớp'
            labelCode='class-type'
            value={filters.category}
            options={Object.values(CLASS_TYPE_CATEGORY).map(type => ({
              id: type,
              name: type,
            }))}
            onChange={value => onChange({ category: value })}
          />

          <SingleChoiceSelect
            label='Cơ sở'
            labelCode='class-place'
            value={filters.classPlace}
            options={classPlaces.map(place => ({
              id: place.id.toString(),
              name: place.name,
            }))}
            onChange={value => onChange({ classPlace: value })}
          />
        </Stack>
      </StyledWrapper>
    </Stack>
  );
};